/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, Injector, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { type Command, FormControl, FormGroup, FormSlideWindowAbstract } from '@dm/core';
import { ToolService } from 'app/common/services';
import { CIFSShare, IpWhiteList } from 'app/common/types/mo';

import { IpWhiteListService } from '../ip-white-list.service';
import { IpWhiteListStrService } from '../ip-white-list-str.service';

@Component({
    selector: 'app-modify-ip-white-list',
    templateUrl: './modify-ip-white-list.component.html',
    styleUrls: ['./modify-ip-white-list.component.scss'],
})
export class ModifyIpWhiteListComponent extends FormSlideWindowAbstract implements OnInit {
    @Input() cifsData: CIFSShare;
    @Input() data: IpWhiteList;
    i18n = this.str.i18n;

    /** 侧滑框标题 */
    title = this.i18n.modifyIpWhiteListTitle;
    loading = false;
    vm: FormGroup;
    errorMessage: { [key: string]: { [key: string]: string } };
    /** CIFS已有的IP白名单规则 */
    ipList = [];

    constructor(
        injector: Injector,
        private str: IpWhiteListStrService,
        private toolService: ToolService,
        private service: IpWhiteListService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.service.getExistIps(this.cifsData.ID, this.cifsData.vstoreId, this.ipList);

        this.windowVisible = true;
        this.pageReady = true;
    }

    initVm(): void {
        this.vm = new FormGroup({
            rules: new FormControl(this.data.rule, {
                validators: [
                    Validators.required,
                    this.service.rulesValidator,
                    this.service.rulesRepeatValidator(this.ipList, this.data.rule),
                ],
            }),
        }, { updateOn: 'blur' });

        this.errorMessage = {
            rules: {
                required: this.toolService.requiredErr(this.i18n.rules),
                ipFormatErr: this.i18n.ipFormatErr,
                ipTypeErr: this.i18n.ipTypeErr,
                ipRepeatErr: this.i18n.ipRepeatErr,
                ipRangeErr: this.i18n.ipRangeErr,
            },
        };
    }

    buildCmds(): Command[] {
        const cmds = [];
        const params: IpWhiteList = {
            ID: this.data.ID,
            rule: this.vm.value.rules,
            vstoreId: this.cifsData.vstoreId,
        };
        cmds.push({
            name: this.i18n.modifyIpWhiteListAction(this.data.rule),
            action: this.service.modifyIpWhiteList(this.data.ID, params),
        });

        return cmds;
    }
}
